export default "__VITE_ASSET__CLXl$aPr__"